import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./index.css";
import AOS from "aos";
import "aos/dist/aos.css";

const HeroSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="screening-hero-section">
      <Container>
        <video
          className="bg-video"
          src="https://video.wixstatic.com/video/11062b_c6ba1531f860478d9bb84c7e7f34d067/1080p/mp4/file.mp4"
          autoPlay
          muted
          loop
          playsInline
        />
        <div className="overlay" />
        <Row className="h-100 align-items-start">
          <Col xs={12} md={6} className="text-container" data-aos="fade-right">
            <p className="screening_hero_title">
              Comprehensive Screening Program
            </p>
            {/* <p className="screening_hero_subtitle">In-Office</p> */}
            <p className="screening_content">
              We design the Program Cycle to limit workflow interruptions in a few simple steps:
              KUR's staff screen Clinic's patient for Doctor evaluation.
              Physician issue orders for the procedure.
              Smart Beat screening done, takes 1 hour.
              All reports generated flow into patient records
              Provider receives report and can add to built in notes section
              Follow-up visit as needed to review and create treatment plan
              KUR staff schedule testing in 12 months
            </p>
            {/* <p className="screening_hero_subtitle">Full-Service</p>
            <p className="screening_content">
              The thorough testing includes a Health Assessment Questionnaire,
              Biometric Screening, Advanced Cardiovascular Tests, and a Blood
              Draw.
            </p>
            <p className="screening_hero_subtitle">Reliable Results</p>
            <p className="screening_content">
              Within a few days of the testing a physician will receive the KUR
              Diagnostics results and look over them. The physician will
              formulate treatment options, if needed, with the patient.
            </p> */}
          </Col>
          <Col xs={12} md={6} className="text-container" data-aos="fade-left">
            <h3 className="screening_hero_subtitle">Neurological Assessment</h3>

            <p className="screening_content">
              We test Electroencephalogram Activity Of The Brain, Electrocardiogram Activity Of The Heart, Visual and Auditory Processing Speeds (evoked potentials) and Subjective Neuropsychological Survey for the related qualifying conditions like Memory loss, Seizures, Cognitive Impairment, Dizziness and Stress Related Consitions - Anxiety, Depression, Post traumatic disorder, Chronic Pain
            </p>
            <h3 className="screening_hero_subtitle">Allergy Testing and Immunotherapy</h3>            
            <p className="screening_content">
              We test 72 different regional environmental allergens including Trees, Grasses, Weeds, Molds, Epithelial for the related qualifiying conditions of Allergic Rhinitis, Chronic Sinus infections, Seasonal Allergy Symptoms, Chronic Tinnitus, Asthma, Wheezing and Upper Respiratory infections
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeroSection;
